<script setup>
import {onMounted, ref} from "vue";
import FormInput from "@/components/FormInput";

const props = defineProps({
  id: {
    type: String,
    default: 'password'
  },
  modelValue: {
    type: String,
    required: false
  },
  autocomplete: {
    default: 'current-password'
  },
  labelGroup: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);

const value = ref(props.modelValue);
onMounted(() => {
  if (value.value) {
    emit('update:modelValue', value.value);
  }
});
</script>

<template>
  <form-input
      type="password"
      :id="props.id"
      :label-group="props.labelGroup"
      v-model="value"
      :required="true"
      :autocomplete="props.autocomplete"
      pattern=".{8,}"
      @input="(event) => emit('update:modelValue', event.target.value)"
  />
</template>